{
  "input": {
    "email": {
      "label": "Email",
      "placeholder": "example@yourwebsite.com"
    }
  }
}
